import { OnboardingSteps } from '../_onboarding-stepper/OnboardingSteps'
import { useOnboardingSteps } from '../_onboarding-stepper/useOnboardingSteps'

type Props = {
  customContent?: React.ReactNode
}

function OnboardingStepperSideMenu({ customContent }: Props) {
  const { steps, activeStep, colorScheme } = useOnboardingSteps()
  return (
    <div className="max-w-400 gap-12 px-[106px]">
      {customContent && (
        <div className="flex flex-col justify-center items-center pb-[4rem]">
          {customContent}
        </div>
      )}
      <OnboardingSteps
        steps={steps}
        activeStep={activeStep}
        colorScheme={colorScheme}
        forceVertical={true}
      />
    </div>
  )
}

export { OnboardingStepperSideMenu }
